export default "__VITE_ASSET__1796dda5__"